import i18n from '../../i18n';
import {get} from 'lodash';

export const getText = (contactType, count) => {

    let transConfig = { // clean contactType-Translation
        'craft': {
            '1': 'company',
            'N': 'companies',
        },
        'tenant': {
            '1': 'contact_person',
            'N': 'contact_persons',
        },
    };
    let trans1 = get(transConfig, `${contactType}.1`, contactType);
    let transN = get(transConfig, `${contactType}.N`, contactType);

    let title = i18n.get('contacts.heading_' + transN);
    let subtitle = [count, i18n.get('contacts.number_of_' + transN)].join(' ');
    let btnAddText = i18n.get('contacts.new_' + trans1);

    return {title, subtitle, btnAddText};
};
